<template>
  <button
    type="button"
    class="relative overflow-hidden border border-primary px-3 py-2 text-sm font-medium text-primary disabled:opacity-40"
    :class="brandButtonClass"
  >
    <slot />
    <template v-if="isLoading">
      <BaseInnerLoading />
    </template>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  isLoading?: boolean
}>()

const brandButtonClass =
  import.meta.env.VITE_ORGANIZATION === "boipa"
    ? "rounded-tl-3xl rounded-br-3xl"
    : "rounded-lg"
</script>
